/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten
export const project = /* GraphQL */ `
  query Project($projectKey: String!) {
    project(projectKey: $projectKey) {
      projectKey
      name
      description
      owners
      tags
      createdAt
      createdBy
      updatedAt
      etag
      stats {
        environments
        flags
        userTargeted
        lastActivity {
          ts
          actor
        }
      }
    }
  }
`;
export const projects = /* GraphQL */ `
  query Projects(
    $owner: String
    $q: String
    $includeStats: Boolean
    $cursor: String
    $limit: Int
  ) {
    projects(
      owner: $owner
      q: $q
      includeStats: $includeStats
      cursor: $cursor
      limit: $limit
    ) {
      items {
        projectKey
        name
        description
        owners
        tags
        createdAt
        createdBy
        updatedAt
        etag
        stats {
          environments
          flags
          userTargeted
          lastActivity {
            ts
            actor
          }
        }
      }
      nextCursor
    }
  }
`;
export const environment = /* GraphQL */ `
  query Environment($projectKey: String!, $envKey: String!) {
    environment(projectKey: $projectKey, envKey: $envKey) {
      projectKey
      envKey
      name
      description
      clientId
      createdAt
      updatedAt
      etag
      flagCount
    }
  }
`;
export const environments = /* GraphQL */ `
  query Environments($projectKey: String!) {
    environments(projectKey: $projectKey) {
      projectKey
      envKey
      name
      description
      clientId
      createdAt
      updatedAt
      etag
      flagCount
    }
  }
`;
export const environmentDeleteImpact = /* GraphQL */ `
  query EnvironmentDeleteImpact($projectKey: String!, $envKey: String!) {
    environmentDeleteImpact(projectKey: $projectKey, envKey: $envKey) {
      envKey
      affectedFlags
    }
  }
`;
export const flag = /* GraphQL */ `
  query Flag($projectKey: String!, $flagKey: String!) {
    flag(projectKey: $projectKey, flagKey: $flagKey) {
      projectKey
      flagKey
      flagType
      description
      maintainer
      tags
      defaultValue
      variations {
        id
        name
        value
      }
      valuesByEnv {
        envKey
        value
        defaultVariationId
        targeting {
          enabled
          rules {
            kind
            value
            variationId
            emails
          }
        }
        lastModified
      }
      createdAt
      updatedAt
      etag
      stats {
        lastChange {
          ts
          actor
        }
        usageApps
        readsPerDay
      }
    }
  }
`;
export const flags = /* GraphQL */ `
  query Flags(
    $projectKey: String!
    $env: String
    $tag: String
    $q: String
    $includeStats: Boolean
    $cursor: String
    $limit: Int
  ) {
    flags(
      projectKey: $projectKey
      env: $env
      tag: $tag
      q: $q
      includeStats: $includeStats
      cursor: $cursor
      limit: $limit
    ) {
      items {
        projectKey
        flagKey
        flagType
        description
        maintainer
        tags
        defaultValue
        variations {
          id
          name
          value
        }
        valuesByEnv {
          envKey
          value
          defaultVariationId
          targeting {
            enabled
            rules {
              kind
              value
              variationId
              emails
            }
          }
          lastModified
        }
        createdAt
        updatedAt
        etag
        stats {
          lastChange {
            ts
            actor
          }
          usageApps
          readsPerDay
        }
      }
      nextCursor
    }
  }
`;
export const projectAudit = /* GraphQL */ `
  query ProjectAudit($projectKey: String!, $cursor: String, $limit: Int) {
    projectAudit(projectKey: $projectKey, cursor: $cursor, limit: $limit) {
      items {
        id
        ts
        actor
        op
        projectKey
        target
        before
        after
        comment
      }
      nextCursor
    }
  }
`;
export const audit = /* GraphQL */ `
  query Audit(
    $projectKey: String
    $flagKey: String
    $actor: String
    $op: [AuditOp!]
    $from: AWSDateTime
    $to: AWSDateTime
    $cursor: String
    $limit: Int
  ) {
    audit(
      projectKey: $projectKey
      flagKey: $flagKey
      actor: $actor
      op: $op
      from: $from
      to: $to
      cursor: $cursor
      limit: $limit
    ) {
      items {
        id
        ts
        actor
        op
        projectKey
        target
        before
        after
        comment
      }
      nextCursor
    }
  }
`;
export const evaluate = /* GraphQL */ `
  query Evaluate(
    $projectKey: String!
    $clientId: String!
    $user: UserContextInput
    $flagKeys: [String!]
  ) {
    evaluate(
      projectKey: $projectKey
      clientId: $clientId
      user: $user
      flagKeys: $flagKeys
    ) {
      flags {
        flagKey
        flagType
        value
        matchedRule
      }
      evaluatedAt
      etag
    }
  }
`;
export const dashboardStats = /* GraphQL */ `
  query DashboardStats {
    dashboardStats {
      projects
      flags
      audit
      live
      computedAt
      etag
    }
  }
`;
export const health = /* GraphQL */ `
  query Health {
    health {
      status
      p99Ms
      ddbWriteAvgMs
    }
  }
`;
export const searchTargetingUsers = /* GraphQL */ `
  query SearchTargetingUsers($projectKey: String!, $q: String!, $limit: Int) {
    searchTargetingUsers(projectKey: $projectKey, q: $q, limit: $limit) {
      email
      displayName
      userType
      appScopes
      role
      status
      etag
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
`;
export const searchDevUsers = /* GraphQL */ `
  query SearchDevUsers($q: String!, $limit: Int) {
    searchDevUsers(q: $q, limit: $limit) {
      email
      displayName
      userType
      appScopes
      role
      status
      etag
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
`;
export const usersDirectory = /* GraphQL */ `
  query UsersDirectory(
    $userType: UserType
    $projectKey: String
    $status: UserStatus
    $q: String
    $cursor: String
    $limit: Int
  ) {
    usersDirectory(
      userType: $userType
      projectKey: $projectKey
      status: $status
      q: $q
      cursor: $cursor
      limit: $limit
    ) {
      items {
        email
        displayName
        userType
        appScopes
        role
        status
        etag
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
      nextCursor
    }
  }
`;
export const directoryUserDeletable = /* GraphQL */ `
  query DirectoryUserDeletable($email: String!) {
    directoryUserDeletable(email: $email) {
      email
      referencedInTargeting
      targetingReferences {
        projectKey
        projectName
        flagKey
        flagName
        envKey
      }
    }
  }
`;
export const me = /* GraphQL */ `
  query Me {
    me {
      email
      displayName
      role
      permissions
    }
  }
`;
export const users = /* GraphQL */ `
  query Users($role: Role, $q: String, $cursor: String, $limit: Int) {
    users(role: $role, q: $q, cursor: $cursor, limit: $limit) {
      items {
        email
        displayName
        role
        status
        etag
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
      nextCursor
    }
  }
`;
export const ldImportJob = /* GraphQL */ `
  query LdImportJob($jobId: ID!) {
    ldImportJob(jobId: $jobId) {
      jobId
      status
      phase
      actor
      startedAt
      finishedAt
      projectsTotal
      projectsProcessed
      currentProjectKey
      flagsWritten
      auditRowsWritten
      ownersUpdated
      ownersMissing
      ownersFailed
      errorMessage
    }
  }
`;
export const createProject = /* GraphQL */ `
  mutation CreateProject($input: CreateProjectInput!) {
    createProject(input: $input) {
      projectKey
      name
      description
      owners
      tags
      createdAt
      createdBy
      updatedAt
      etag
      stats {
        environments
        flags
        userTargeted
        lastActivity {
          ts
          actor
        }
      }
    }
  }
`;
export const updateProject = /* GraphQL */ `
  mutation UpdateProject($projectKey: String!, $input: UpdateProjectInput!) {
    updateProject(projectKey: $projectKey, input: $input) {
      projectKey
      name
      description
      owners
      tags
      createdAt
      createdBy
      updatedAt
      etag
      stats {
        environments
        flags
        userTargeted
        lastActivity {
          ts
          actor
        }
      }
    }
  }
`;
export const deleteProject = /* GraphQL */ `
  mutation DeleteProject($projectKey: String!, $auditContextEnvKey: String) {
    deleteProject(
      projectKey: $projectKey
      auditContextEnvKey: $auditContextEnvKey
    )
  }
`;
export const createEnvironment = /* GraphQL */ `
  mutation CreateEnvironment(
    $projectKey: String!
    $input: CreateEnvironmentInput!
  ) {
    createEnvironment(projectKey: $projectKey, input: $input) {
      projectKey
      envKey
      name
      description
      clientId
      createdAt
      updatedAt
      etag
      flagCount
    }
  }
`;
export const updateEnvironment = /* GraphQL */ `
  mutation UpdateEnvironment(
    $projectKey: String!
    $envKey: String!
    $input: UpdateEnvironmentInput!
  ) {
    updateEnvironment(projectKey: $projectKey, envKey: $envKey, input: $input) {
      projectKey
      envKey
      name
      description
      clientId
      createdAt
      updatedAt
      etag
      flagCount
    }
  }
`;
export const deleteEnvironment = /* GraphQL */ `
  mutation DeleteEnvironment($projectKey: String!, $envKey: String!) {
    deleteEnvironment(projectKey: $projectKey, envKey: $envKey)
  }
`;
export const createFlag = /* GraphQL */ `
  mutation CreateFlag($projectKey: String!, $input: CreateFlagInput!) {
    createFlag(projectKey: $projectKey, input: $input) {
      projectKey
      flagKey
      flagType
      description
      maintainer
      tags
      defaultValue
      variations {
        id
        name
        value
      }
      valuesByEnv {
        envKey
        value
        defaultVariationId
        targeting {
          enabled
          rules {
            kind
            value
            variationId
            emails
          }
        }
        lastModified
      }
      createdAt
      updatedAt
      etag
      stats {
        lastChange {
          ts
          actor
        }
        usageApps
        readsPerDay
      }
    }
  }
`;
export const updateFlag = /* GraphQL */ `
  mutation UpdateFlag(
    $projectKey: String!
    $flagKey: String!
    $input: UpdateFlagInput!
  ) {
    updateFlag(projectKey: $projectKey, flagKey: $flagKey, input: $input) {
      projectKey
      flagKey
      flagType
      description
      maintainer
      tags
      defaultValue
      variations {
        id
        name
        value
      }
      valuesByEnv {
        envKey
        value
        defaultVariationId
        targeting {
          enabled
          rules {
            kind
            value
            variationId
            emails
          }
        }
        lastModified
      }
      createdAt
      updatedAt
      etag
      stats {
        lastChange {
          ts
          actor
        }
        usageApps
        readsPerDay
      }
    }
  }
`;
export const setFlagEnvValue = /* GraphQL */ `
  mutation SetFlagEnvValue(
    $projectKey: String!
    $flagKey: String!
    $envKey: String!
    $input: SetFlagEnvValueInput!
  ) {
    setFlagEnvValue(
      projectKey: $projectKey
      flagKey: $flagKey
      envKey: $envKey
      input: $input
    ) {
      projectKey
      flagKey
      flagType
      description
      maintainer
      tags
      defaultValue
      variations {
        id
        name
        value
      }
      valuesByEnv {
        envKey
        value
        defaultVariationId
        targeting {
          enabled
          rules {
            kind
            value
            variationId
            emails
          }
        }
        lastModified
      }
      createdAt
      updatedAt
      etag
      stats {
        lastChange {
          ts
          actor
        }
        usageApps
        readsPerDay
      }
    }
  }
`;
export const deleteFlag = /* GraphQL */ `
  mutation DeleteFlag(
    $projectKey: String!
    $flagKey: String!
    $auditContextEnvKey: String
    $comment: String
  ) {
    deleteFlag(
      projectKey: $projectKey
      flagKey: $flagKey
      auditContextEnvKey: $auditContextEnvKey
      comment: $comment
    )
  }
`;
export const createDirectoryUser = /* GraphQL */ `
  mutation CreateDirectoryUser($input: CreateDirectoryUserInput!) {
    createDirectoryUser(input: $input) {
      email
      displayName
      userType
      appScopes
      role
      status
      etag
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
`;
export const updateDirectoryUser = /* GraphQL */ `
  mutation UpdateDirectoryUser(
    $email: String!
    $input: UpdateDirectoryUserInput!
    $expectedEtag: String!
  ) {
    updateDirectoryUser(
      email: $email
      input: $input
      expectedEtag: $expectedEtag
    ) {
      email
      displayName
      userType
      appScopes
      role
      status
      etag
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
`;
export const deleteDirectoryUser = /* GraphQL */ `
  mutation DeleteDirectoryUser($email: String!, $expectedEtag: String!) {
    deleteDirectoryUser(email: $email, expectedEtag: $expectedEtag)
  }
`;
export const setUserRole = /* GraphQL */ `
  mutation SetUserRole($input: SetUserRoleInput!) {
    setUserRole(input: $input) {
      email
      displayName
      role
      status
      etag
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
`;
export const revokeUserRole = /* GraphQL */ `
  mutation RevokeUserRole($email: String!) {
    revokeUserRole(email: $email)
  }
`;
export const publishFlagChange = /* GraphQL */ `
  mutation PublishFlagChange($input: PublishFlagChangeInput!) {
    publishFlagChange(input: $input) {
      projectKey
      envKey
      clientId
      flagKey
      flagType
      value
      etag
      changedBy
      changedAt
    }
  }
`;
export const startLdImport = /* GraphQL */ `
  mutation StartLdImport {
    startLdImport {
      jobId
      status
      phase
      actor
      startedAt
      finishedAt
      projectsTotal
      projectsProcessed
      currentProjectKey
      flagsWritten
      auditRowsWritten
      ownersUpdated
      ownersMissing
      ownersFailed
      errorMessage
    }
  }
`;
export const onFlagChange = /* GraphQL */ `
  subscription OnFlagChange($projectKey: String!, $clientId: String!) {
    onFlagChange(projectKey: $projectKey, clientId: $clientId) {
      projectKey
      envKey
      clientId
      flagKey
      flagType
      value
      etag
      changedBy
      changedAt
    }
  }
`;
//# sourceMappingURL=queries.js.map